<template>
    <div>
        <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->

        </base-header>

        <div class="container-fluid mt--7">
            <div class="card shadow bg-secondary">
                <div class="card-header">
                    <div class="row">
                        <div class="col-12 col-sm-6 align-self-center"><h3 class="mb-0">User details</h3></div>
                        <div class="col-12 col-sm-6 text-right align-self-center">
                            <router-link :to="{ name: 'users' }" class=" btn btn-secondary btn-icon-only rounded-circle mt-1">
                                <i class="fa fa-arrow-left"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="card-body pt-0 pt-md-4">
                    <div>
                        <div class="row">
                            <div class="col">
                                <div class="table-responsive mb-4">
                                    <table class="table tablesorter">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    First name:
                                                </td>
                                                <td>
                                                    {{user.firstName}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Last name:
                                                </td>
                                                <td>
                                                    {{user.lastName}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Phone number:
                                                </td>
                                                <td>
                                                    {{user.phone}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Date of birth:
                                                </td>
                                                <td>
                                                    {{user.dob}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Country:
                                                </td>
                                                <td>
                                                    {{user.country}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Country code:
                                                </td>
                                                <td>
                                                    {{user.countryCode}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Region:
                                                </td>
                                                <td>
                                                    {{user.region}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    City:
                                                </td>
                                                <td>
                                                    {{user.city}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    First address:
                                                </td>
                                                <td>
                                                    {{user.address1}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Second address:
                                                </td>
                                                <td>
                                                    {{user.address2}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Postal code:
                                                </td>
                                                <td>
                                                    {{user.postalCode}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Email:
                                                </td>
                                                <td>
                                                    {{user.email}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Occupation details:
                                                </td>
                                                <td>
                                                    {{user.occupationDetails}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Oranges:
                                                </td>
                                                <td>
                                                    {{user.oranges}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Rewarded for trees:
                                                </td>
                                                <td>
                                                    {{user.rewardTrees ? 'Yes':'No'}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Rewarded for bicycles:
                                                </td>
                                                <td>
                                                    {{user.rewardBicycles ? 'Yes':'No'}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Policies:
                                                </td>
                                                <td>
                                                    {{user.policies}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Notifications read:
                                                </td>
                                                <td>
                                                    {{user.notificationsRead ? 'Yes':'No'}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Payment token:
                                                </td>
                                                <td>
                                                    {{user.paymentToken}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Notification token:
                                                </td>
                                                <td>
                                                    {{user.notificationToken}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Language code:
                                                </td>
                                                <td>
                                                    {{user.languageCode }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Number of the ID document:
                                                </td>
                                                <td>
                                                    {{user.documentNumber }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    User Id number:
                                                </td>
                                                <td>
                                                    {{user.idNumber}}
                                                </td>
                                            </tr>
                                            <tr v-if="user.notifications.length">
                                                <td colspan="2">
                                                    <div class="card shadow">
                                                        <div class="card-header border-0 bg-transparent">
                                                            <div class="row align-items-center">
                                                                <div class="col">
                                                                    <a data-toggle="collapse"
                                                                       class="collapsed"
                                                                       href="#notifications-details"
                                                                       role="button"
                                                                       aria-expanded="false"
                                                                       aria-controls="notifications-details">
                                                                        <h3 class="mb-0">
                                                                            Notifications <i class="align-middle ml-2 fas"></i>
                                                                        </h3>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id="notifications-details" class="col-12 card-body collapse">
                                                            <div class="col-12" v-for="(notification) in user.notifications" :key="notification['.key']">

                                                                <div class="card shadow mb-4">
                                                                    <div class="card-header border-0 bg-transparent">
                                                                        <div class="row align-items-center">
                                                                            <div class="col">
                                                                                <a data-toggle="collapse"
                                                                                   class="collapsed"
                                                                                   :href="'#notifications-details'+notification.id"
                                                                                   role="button"
                                                                                   aria-expanded="false"
                                                                                   :aria-controls="'notifications-details'+notification.id">
                                                                                    <h3 class="mb-0">
                                                                                        {{notification.title}} <i class="align-middle ml-2 fas"></i>
                                                                                    </h3>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div :id="'notifications-details'+notification.id" class="col-8 card-body collapse">
                                                                        <table class="table tablesorter">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>
                                                                                        Title:
                                                                                    </td>
                                                                                    <td>
                                                                                        {{notification.title}}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        Description:
                                                                                    </td>
                                                                                    <td>
                                                                                        {{notification.description}}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        Date:
                                                                                    </td>
                                                                                    <td>
                                                                                        {{notification.date}}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <expandable-image class="mt-2 rounded-sm w-100" v-bind:src="notification.imageUrl" alt="Image" />
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="user.idPictures.length">
                                                <td colspan="2">
                                                    <div class="card shadow">
                                                        <div class="card-header border-0 bg-transparent">
                                                            <div class="row align-items-center">
                                                                <div class="col">
                                                                    <a data-toggle="collapse"
                                                                       class="collapsed"
                                                                       href="#general-details"
                                                                       role="button"
                                                                       aria-expanded="false"
                                                                       aria-controls="general-details">
                                                                        <h3 class="mb-0">
                                                                            Pictures of the ID document <i class="align-middle ml-2 fas"></i>
                                                                        </h3>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id="general-details" class="col-10 card-body collapse">
                                                            <div class="col-3" v-for="(picture) in user.idPictures" :key="picture['.key']">
                                                                <expandable-image class="mt-2 rounded-sm w-100" v-bind:src="picture" alt="Document" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    window.$ = window.jQuery = require('jquery');
    require('jquery-ui-sortable');
    require('bootstrap/dist/js/bootstrap.js');
    import Vue from "vue";
    import VueExpandableImage from 'vue-expandable-image'
    Vue.use(VueExpandableImage)
    import firebase from '../config/db.js';
    import moment from 'moment'
    import swal from 'sweetalert2'

    export default {
        data() {
            return {
                id: this.$router.currentRoute.params.id,
                user: {
                    notifications: [],
                    idPictures: []
                }
            }
        },
        mounted: function () {
            this.getUsersData();
        },
        methods: {
            getUsersData: function () {
                firebase.firestore().collection("users").doc(this.id).get().then((doc) => {
                    if (doc.exists) {
                        this.user = doc.data();
                        let dob = this.user.dob;
                        this.user.dob = dob ? moment(dob.toDate()).format('MMMM Do YYYY, h:mm:ss A') : "";
                        if (this.user.notifications.length > 0) {
                            this.user.notifications.forEach((element) => {
                                let date = element.date;
                                element.date = date ? moment(date.toDate()).format('MMMM Do YYYY, h:mm:ss A') : "";
                            })
                        }
                    } else {
                        swal.fire({
                            text: 'No such user!',
                            type: "error",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.$router.replace('users');
                    }
                });
            }
        }
    };
</script>
<style></style>
